import { RightEnum } from "@tubo/api-models/business/rbac/rbac.enums";

const RIGHT_ORDER: Record<string, number> = {
  [RightEnum.Deny]: 0,
  [RightEnum.View]: 1,
  [RightEnum.Review]: 2,
  [RightEnum.Edit]: 3,
  [RightEnum.Admin]: 4,
};

export interface ResourceActionPolicy {
  canView: boolean;
  canEdit: boolean;
  canAdmin: boolean;
}

/** 统一将服务端解算的有效权限转换为资源操作能力。 */
export function resourceActionPolicy(
  effectiveRight: string | undefined,
): ResourceActionPolicy {
  const level = effectiveRight ? (RIGHT_ORDER[effectiveRight] ?? -1) : -1;
  return {
    canView: level >= RIGHT_ORDER[RightEnum.View],
    canEdit: level >= RIGHT_ORDER[RightEnum.Edit],
    canAdmin: level >= RIGHT_ORDER[RightEnum.Admin],
  };
}

/** 批量操作只在所有选中资源都满足所需能力时可用。 */
export function batchResourceActionPolicy(
  effectiveRights: Array<string | undefined>,
): ResourceActionPolicy {
  if (effectiveRights.length === 0) {
    return { canView: false, canEdit: false, canAdmin: false };
  }
  return effectiveRights
    .map(resourceActionPolicy)
    .reduce<ResourceActionPolicy>(
      (lowest, current) => ({
        canView: lowest.canView && current.canView,
        canEdit: lowest.canEdit && current.canEdit,
        canAdmin: lowest.canAdmin && current.canAdmin,
      }),
      { canView: true, canEdit: true, canAdmin: true },
    );
}
